import { useNodeId } from "@xyflow/react";
import { ReactNode } from "react";
import { useSetAtom } from "jotai";
import { isNodeHoveredAtomFamily } from "@zapier/canvas-state";
import styles from "./NodeHoverWrapper.module.css";

interface Props {
  children: ReactNode;
}

export function NodeHoverWrapper({ children }: Props) {
  const nodeId = useNodeId();
  const setIsHovered = useSetAtom(isNodeHoveredAtomFamily(nodeId));

  return (
    <div
      className={styles.root}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      {children}
    </div>
  );
}
